import { Component } from "@angular/core";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { SettingsService } from "../../shared/settings.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
  imports: [NewUiButton],
})
export class LoginComponent {
  login(): void {
    this.settings.loginWithPopup();
  }

  constructor(private readonly settings: SettingsService) {}
}
